// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"_0bc5e8de02--wrapper--OG3IC","icon":"_0bc5e8de02--icon--XOZ3Q","title":"_0bc5e8de02--title--w6TQk","message":"_0bc5e8de02--message--MKR1K"};